import React from 'react'

export const EventRowDivider = () => {
    return (
      <hr style={{borderTop: '1px solid rgb(171, 171, 171)', width: '100%'}} />
    )
}
